import { render, staticRenderFns } from "./PublicShopView.vue?vue&type=template&id=0f664922&scoped=true"
import script from "./PublicShopView.vue?vue&type=script&lang=js"
export * from "./PublicShopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f664922",
  null
  
)

export default component.exports